import { useTranslation } from 'react-i18next';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Box } from 'reflexbox';

import { useAuthenticatedUser, useFeatureDetails, useViewerRoles } from '@treams/treams-hooks';
import { FeatureName } from '@treams/treams-network';
import { Jumbo, Tabs } from '@treams/treams-ui';

import NotificationsCustomEmailDomain from './NotificationsCustomEmailDomain';
import NotificationsEmailEditor from './NotificationsEmailEditor';
import SentEmailsListContainer from './SentEmailsListContainer';

export default function EmailsSettings() {
	const { isHRBusinessPartner } = useViewerRoles();
	const { t } = useTranslation();

	const { username } = useAuthenticatedUser();
	const { available: hasCustomDomainEmail, loading: loadingFeatures } = useFeatureDetails(
		FeatureName.CustomEmailDomain,
	);

	return (
		<>
			<Jumbo
				title={t('settings.notifications.title')}
				description={t('settings.notifications.description')}
				footer={
					<Tabs.Container mb="-1px">
						<Tabs.Item
							title={t('settings.notifications.email.title')}
							path="/settings/notifications/email"
						/>
						{username === 'support' && (
							<Tabs.Item
								title={t('settings.emails.sent.title')}
								path="/settings/notifications/sent-emails"
							/>
						)}
						{hasCustomDomainEmail && !isHRBusinessPartner && (
							<Tabs.Item
								title={t('settings.notifications.customEmailDomain.title')}
								path="/settings/notifications/custom-email-domain"
							/>
						)}
					</Tabs.Container>
				}
			/>
			<Switch>
				<Route path="/settings/notifications/email">
					<NotificationsEmailEditor />
				</Route>
				{(hasCustomDomainEmail || loadingFeatures) && (
					<Route path="/settings/notifications/custom-email-domain">
						<NotificationsCustomEmailDomain />
					</Route>
				)}
				<Route path="/settings/notifications/sent-emails">
					<Box p={4}>
						<SentEmailsListContainer />
					</Box>
				</Route>
				<Route>
					<Redirect to="/settings/notifications/email" />
				</Route>
			</Switch>
		</>
	);
}
